"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, use, useCallback, useMemo } from "react";
import { clearFormFieldErrorForInstance, clearFormFieldErrorsForInstance, getFormFieldErrorsSnapshot, setFormFieldErrorsForInstance, useFormFieldErrorsMap } from "./formFieldErrorStore";
export type FormValidationContextValue = {
  clearAllFieldErrors: () => void;
  clearFieldError: (name: string) => void;
  fieldErrors: Record<string, string>;
  formInstanceId: string;
  setFieldErrors: (errors: Record<string, string>) => void;
};
const FormValidationContext = createContext<FormValidationContextValue | null>(null);
export function FormValidationProvider(t0) {
  const $ = _c(15);
  const {
    children,
    formInstanceId
  } = t0;
  const fieldErrors = useFormFieldErrorsMap(formInstanceId);
  let t1;
  if ($[0] !== formInstanceId) {
    t1 = errors => {
      setFormFieldErrorsForInstance(formInstanceId, errors);
    };
    $[0] = formInstanceId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setFieldErrors = t1;
  let t2;
  if ($[2] !== formInstanceId) {
    t2 = name => {
      clearFormFieldErrorForInstance(formInstanceId, name);
    };
    $[2] = formInstanceId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const clearFieldError = t2;
  let t3;
  if ($[4] !== formInstanceId) {
    t3 = () => {
      clearFormFieldErrorsForInstance(formInstanceId);
    };
    $[4] = formInstanceId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const clearAllFieldErrors = t3;
  let t4;
  if ($[6] !== clearAllFieldErrors || $[7] !== clearFieldError || $[8] !== fieldErrors || $[9] !== formInstanceId || $[10] !== setFieldErrors) {
    t4 = {
      fieldErrors,
      formInstanceId,
      setFieldErrors,
      clearFieldError,
      clearAllFieldErrors
    };
    $[6] = clearAllFieldErrors;
    $[7] = clearFieldError;
    $[8] = fieldErrors;
    $[9] = formInstanceId;
    $[10] = setFieldErrors;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const value = t4;
  let t5;
  if ($[12] !== children || $[13] !== value) {
    t5 = <FormValidationContext.Provider value={value}>{children}</FormValidationContext.Provider>;
    $[12] = children;
    $[13] = value;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
export function useFormValidation(): FormValidationContextValue | null {
  return use(FormValidationContext);
}

/** Read field errors when the consumer is not under FormValidationProvider (RSC children). */
export function usePublicFormFieldError(formInstanceId, fieldName) {
  const errors = useFormFieldErrorsMap(formInstanceId);
  return formInstanceId ? errors[fieldName] : undefined;
}
export function readFormFieldErrorsForInstance(formInstanceId: string): Record<string, string> {
  return getFormFieldErrorsSnapshot(formInstanceId);
}